import { useAppDispatch } from 'store/hooks';
import playlistSelectors from '../selectors';
import playlistActions from '../actions';
import { useEffect } from 'react';
import { IApiGetPlaylistParam } from 'modules/playlist/interfaces/api';

const useGetListPlaylists = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const data = playlistSelectors.getListPlaylists();
  const playlistsParams = playlistSelectors.getPlaylistsParam();

  const mutate = (params: IApiGetPlaylistParam) => {
    dispatch(
      playlistActions.setPlaylistsParam(params)
    );
  };

  useEffect(() => {
    if (!isLazy) {
      mutate({ page: 1, size: 10 });
    }
  }, []);

  return [data, playlistsParams, mutate] as const;
};

export default useGetListPlaylists;
